/**
 * Estado observable de la sincronización para la interfaz.
 */
import { useSyncExternalStore } from 'react';

export type SyncPhase = 'idle' | 'syncing' | 'offline' | 'error';

export interface SyncState {
  signedIn: boolean;
  email: string | null;
  phase: SyncPhase;
  pending: number;
  rejected: number;
  lastSyncAt: number | null;
  lastError: string | null;
  serverAvailable: boolean | null;
}

let state: SyncState = {
  signedIn: false,
  email: null,
  phase: 'idle',
  pending: 0,
  rejected: 0,
  lastSyncAt: null,
  lastError: null,
  serverAvailable: null,
};
const subs = new Set<() => void>();

export function getSyncState(): SyncState {
  return state;
}

export function setSyncState(patch: Partial<SyncState>): void {
  state = { ...state, ...patch };
  subs.forEach((s) => s());
}

export function useSyncState(): SyncState {
  return useSyncExternalStore(
    (cb) => {
      subs.add(cb);
      return () => subs.delete(cb);
    },
    () => state,
  );
}
